export default __webpack_public_path__ + "static/stringywaxblobs-15c2633356df815f6a25fa077fc99746.png";